import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  LOAD_PERFORMANCE: `${name}:load_performance`,
  SET_PERF_START_DATE: `${name}:set_perf_start_date`,
  SET_PERF_END_DATE: `${name}:set_perf_end_date`,
  START_LOADING_PERFORMANCE: `${name}:start_loading_performance`,
  LOAD_PERFORMANCE_SUCCESS: `${name}:load_performance_success`,
  LOAD_PERFORMANCE_FAILURE: `${name}:load_performance_failure`,
};

// ACTIONS
export function loadPerformance() {
  return (dispatch, getState) => {
    const ticker = getState().params.ticker;
    let url = `${process.env.REACT_APP_API_URL}/data/?`
    const request = {
      method: 'GET',
      url: url,
      params: {
        ticker: ticker
      },
    };

    dispatch({ type: actionTypes.START_LOADING_PERFORMANCE });

    return axios(request)
      .then((response) => {
        console.log('REQUEST', request)
        console.log('RESPONSE', response)
        dispatch({ type: actionTypes.LOAD_PERFORMANCE_SUCCESS, value: response.data });
      })
      .catch((error) => {
        console.error(error);
        dispatch({ type: actionTypes.LOAD_PERFORMANCE_FAILURE });
      });
  };
}

export function setPerfStartDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_PERF_START_DATE, payload: value });
  };
}

export function setPerfEndDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_PERF_END_DATE, payload: value });
  };
}


// WEBPACK FOOTER //
// ./src/actions/data.js